<template>
  <div id="app">
    <router-view></router-view>
    <ul v-if="showSeriesButton" class="seriesButton clearfix">
      <li id="aishow">
        <a :href="`${aiDomain}/sprite.html?uibaiufasi=8jyt*yu*122`"
          ><img src="./assets/images/wardenInspecearth.png"
        /></a>
      </li>
      <li id="star">
        <a :href="`${mapDomain}/pptAi.html`"
          ><img src="./assets/images/wardenInspectStar.png"
        /></a>
      </li>
      <li class="current" id="web">
        <a :href="`${aiWebDomain}/?person=oneself`"
          ><img src="./assets/images/wardenInspectaiweb.png"
        /></a>
      </li>
      <li id="optimization">
        <a href="http://47.94.109.100:8016/wardeninspect_ai.html"
          ><img src="./assets/images/wardenInspectai.png"
        /></a>
      </li>
      <li id="bdmap">
        <a :href="`${mapDomain}/intelligence.html?uibaiufasi=8jyt*yu*122`"
          ><img src="./assets/images/wardenInspectBD.png"
        /></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    if (this.searchToOBJ(location.search).person === "oneself") {
      this.showSeriesButton = true;
    }
  },
  data() {
    return {
      showSeriesButton: false,
      aiDomain: "http://aishow.ckzone.cn",
      aiWebDomain: "http://zgc-ai.cn",
      mapDomain: "http://map.zgcjm.org"
    };
  }
};
</script>

<style lang="less">
.seriesButton {
  position: absolute;
  right: 0;
  top: 20px;
  z-index: 2147483647;
  li {
    float: left;
    margin-right: 10px;
    opacity: 0.5;
    &.current {
      opacity: 1;
    }
    a {
      display: block;
      width: 35px;
      height: 35px;
    }
    img {
      width: 100%;
    }
  }
}
</style>
